import {
  LogoHauteGaspesie,
  LogoMutuoHorizontal,
  LogoRefrain,
  LogoSerresTessierHorizontal,
} from 'app/design/branding/logo';
import { LogoOneLine } from 'app/design/icons/logo-one-line';
import { LogoOneLinePartake } from 'app/design/icons/logo-one-line-partake';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { View } from 'react-native';
import { useTheme } from 'app/shopify';
import { env } from '../../env';

export function ModalLogoComponent() {
  const theme = useTheme();
  if (isWhiteLabel(WhiteLabel.Refrain)) {
    return (
      <View style={{ marginTop: -15 }}>
        <LogoRefrain height={75} width={187} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.SerresTessier)) {
    return (
      <View style={{ marginTop: -5 }}>
        <LogoSerresTessierHorizontal height={22} width={139} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.Mutuo)) {
    return (
      <View style={{ marginTop: -5 }}>
        <LogoMutuoHorizontal height={23} width={138} />
      </View>
    );
  }

  if (isWhiteLabel(WhiteLabel.HauteGaspesie)) {
    return (
      <View style={{ marginTop: -5 }}>
        <LogoHauteGaspesie height={23} width={43.125} />
      </View>
    );
  }

  // prettier-ignore
  return env.IS_PARTAKE ? <LogoOneLinePartake /> : <LogoOneLine color={theme.colors['white-label.header.on-header']} />;
}
